import React, { useState } from 'react';
import { Table, Button, Box, Icon, H3, P, Spinner, Tbody, Tr, Td, Thead, Th, Card } from '@veracity/vui';
import { useCreateChecklist, useTemplates } from '../api/templates';
import TemplateDrawer from '../components/TemplateDrawer';
import { useNavigate } from 'react-router-dom';
import TemplateSelectModal from '../components/TemplateSelectModal';

const TemplatesView = () => {
  const { data: templates, isLoading, error } = useTemplates();
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  

  const navigate = useNavigate();

  const handleViewTemplate = (template) => {
    setSelectedTemplate(template);
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedTemplate(null);
  };

  const handleCreateChecklist = () => {
    setIsModalOpen(true);
  }

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  if (isLoading) return <Box alignItems="center" justifyContent="center" minH={700}><Spinner /></Box>;

  if (error) {
    return (
      <Box alignItems="center" justifyContent="center" minH={700}>
        <Box alignItems="center" elevation={2} flexDirection="column" justifyContent="center" maxW={580} minW={580} p={3}>
          <Box><Icon color="energyRed.45" name="falExclamationTriangle" size="xxl" /></Box>
          <H3 my={2}>Something went wrong</H3>
          <P>The operation could not be completed. Try again later.</P>
          <Button mt={3} onClick={() => window.location.reload()}>Try again</Button>
        </Box>
      </Box>
    );
  }

  return (
    <>
    {/* <H3 mb={6} textAlign="center">Checklist Templates</H3> */}
    <Card p={2}>
    <Box p={2} justifyContent="center" minH={700} display="flex">
      <Table variant='basic'>
        <Thead>
            <Tr>
                <Th>Template Name</Th>
                <Th>Actions</Th>
            </Tr>
        </Thead>
        <Tbody>
          
          {(templates || []).map(template => (
            <Tr key={template.id}>
              <Td textAlign="left">{template.name}</Td>
              <Td>
                <Box display="flex" flex-direction="column" gap={2}>
                  <Button 
                    variant="secondaryDark"
                    size="sm"
                    iconRight="falArrowRight"
                    onClick={() => handleViewTemplate(template)}
                  >
                    View
                  </Button>
                  <Button 
                    variant="primaryDark"
                    size="sm"
                    iconRight="falPlus"
                    onClick={() => handleCreateChecklist()}
                    // onClick={() => window.location.href = `/checklist/new/${template.id}`}
                  >
                    Add
                  </Button>
                </Box>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      <TemplateDrawer 
        isOpen={isDrawerOpen} 
        onClose={handleCloseDrawer}
        template={selectedTemplate}
      />
    </Box>
    </Card>
    <Box mt={4} gap={4} justifyContent="center">
      <Button text="View Checklists" onClick={()=>navigate("/checklists")}/>
      <Button text="New Checklist" 
        onClick={handleCreateChecklist}
      />
    </Box>

    <TemplateSelectModal
      isOpen={isModalOpen}
      onClose={handleCloseModal}
      templates={templates}
    />
    </>
  );
};

export default TemplatesView;